import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalConfirmacaoService } from 'src/app/shared/services/modal-confirmacao.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { IQuestionarios } from '../../models/questionarios';
import { QuestionariosService } from '../../services/questionarios.service';

@Component({
  selector: 'app-list-questionarios',
  templateUrl: './list-questionarios.component.html',
  styleUrls: ['./list-questionarios.component.scss']
})
export class ListQuestionariosComponent {
  @Output() mudouPagina = new EventEmitter<number>();
  @Output() mudouTamanhoPagina = new EventEmitter<number>();
  @Output() recarregarListagem = new EventEmitter();
  @Input() questionarios: IQuestionarios[] = [];
  @Input() dadosPaginacao: {
    paginaSelecionada: number;
    tamanhoPagina: number;
    totalPaginas: number;
    itensTotal: number;
  } = {
      paginaSelecionada: 0,
      tamanhoPagina: 10,
      totalPaginas: 0,
      itensTotal: 0
    };
  constructor(private readonly questionarioService: QuestionariosService,
    private readonly modalConfirmacao: ModalConfirmacaoService,
    private readonly toastService: ToastService) { }


  public toogleEmpresaStatus(questionarioId: string, status: boolean): void {
    const textoStatus = status ? 'desativar' : 'ativar';

    this.modalConfirmacao
      .abrirModalConfirmacao({
        mensagem: `Tem certeza que deseja ${textoStatus} a Questionários?`
      })
      .subscribe((resposta) => {
        if (!resposta) return;

        if (status) {
          this.questionarioService.desativarQuestionarios(questionarioId).subscribe((resposta) => {
            if (resposta.messages && resposta.messages.length > 0) {
              this.toastService.toast(resposta.messages);
            }

            if (resposta.isSucceed) {
              this.recarregarListagem.emit();
            }
          });
        } else {
          this.questionarioService.ativarQuestionarios(questionarioId).subscribe((resposta) => {
            if (resposta.messages && resposta.messages.length > 0) {
              this.toastService.toast(resposta.messages);
            }

            if (resposta.isSucceed) {
              this.recarregarListagem.emit();
            }
          });
        }
      });
  }


}
